module.exports = __webpack_public_path__ + "img/nrslogovectorallwhitestacked.7a0448a3.png";